export default __webpack_public_path__ + "static/media/LG-PRN.097255a0.png";